import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";

export const PageWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 48px;
  margin: 48px 0;
  width: 100%;
  @media only screen and (max-width: 600px) {
    margin: 32px 0;
  }
`;

export const QuestionList = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ConditionList = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
